import { Typography } from 'antd';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styles from './index.module.css';

import { getTransactions } from '../../../Services/PFMClient/DashboardService';

import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../App';
import { pushEventToParent } from '../../../Utils/eventUtils';
import { ReactComponent as BackButton } from '../../../Assets/left-arrow.svg';
import { ReactComponent as PbMoney } from '../../../Assets/pbmoney.svg';
import RecurringTransactions from '../RecurringTransactions';
import NudgeDetails from './NudgeDetails';
import NudgeItem from './NudgeItem';
import NavigationHeader from '../Header/NavigationHeader';
import { startCase } from 'es-toolkit';
import HeaderSubHeader from '../Header/HeaderSubHeader';

const NudgesScreenDashboard: React.FC = () => {
  const [selectedNudgeTransaction, setSelectedNudgeTransaction] = useState([]);
  const location = useLocation();

  const navigate = useNavigate();

  const {
    isKeyInshigtsVisible,
    selectedNudge,
    setSelectedNudge,
    nudges,
    accountIds,
    statusData,
    monthlyPaymentsVisible,
    setMonthlyPaymentsVisible,
    setIsKeyInshigtsVisible,
    setBackButtonHandler,
    isAssetDashboardRendered,
  }: any = useContext(AppContext);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const nudgeId = pathParts[pathParts.length - 1];

    if (nudgeId && location.pathname.includes(`/nudges/${nudgeId}`)) {
      const selectedNudge = nudges.find(
        (nudge: any) => nudge.nudgeId === nudgeId
      );
      navigate(`/nudges/${nudgeId}`);
      pushEventToParent({
        eventCode: 'INSIGHT_' + selectedNudge.category,
      });
      setSelectedNudge(selectedNudge);

      if (
        selectedNudge.category === 'UPCOMING_EMI_REMINDER' ||
        selectedNudge.category === 'UPCOMING_SIP_INVESTMENT'
      ) {
        setMonthlyPaymentsVisible(true);
      }
    }
  }, [location.pathname, nudges]);

  const updateNudgeTrasactions = async () => {
    const trasactions = await getTransactions({
      accountIdList: accountIds,
      txnRefIdList: selectedNudge.parameter.filter(
        (para: any) => para.name === 'txnRefIdList'
      )[0].value,
    });

    setSelectedNudgeTransaction(trasactions.data.elements);
  };

  useEffect(() => {
    if (selectedNudge !== undefined) {
      if (
        selectedNudge.parameter.filter(
          (para: any) => para.name === 'txnRefIdList'
        ).length !== 0
      ) {
        updateNudgeTrasactions();
      }
    }
  }, [selectedNudge]);

  const accRecurringPayments = useMemo(() => {
    let selectedLinkRef = '';

    if (
      selectedNudge &&
      selectedNudge.parameter &&
      selectedNudge.parameter.length
    ) {
      const nudgeFilter = selectedNudge.parameter.filter(
        (a: any) => a.name === 'linkedAccRef'
      );
      if (nudgeFilter && nudgeFilter.length) {
        selectedLinkRef = nudgeFilter[0].value;
      }
    }

    const filterAcc = statusData.current.accountDetails.filter(
      (acc: any) => acc.linkRefNumber === selectedLinkRef
    );
    if (filterAcc && filterAcc.length) {
      return filterAcc[0].maskedAccountNumber.slice(-6);
    } else return '';
  }, [monthlyPaymentsVisible, selectedNudge]);

  const handleBackNavigation = useCallback(() => {
    if (selectedNudge !== undefined) {
      setSelectedNudge(undefined);
      if (monthlyPaymentsVisible) {
        setMonthlyPaymentsVisible(false);
      }
    } else if (isKeyInshigtsVisible) {
      if (location.pathname === '/nudges') {
        // Check if we came from AssetsDashboard
        if (isAssetDashboardRendered.current) {
          navigate('/home');
        } else {
          pushEventToParent({ eventCode: 'BACK_BUTTON_PRESSED' });
        }
      } else {
        setIsKeyInshigtsVisible(false);
      }
    }
  }, [
    selectedNudge,
    monthlyPaymentsVisible,
    isKeyInshigtsVisible,
    location.pathname,
    location.state,
    navigate,
  ]);

  useEffect(() => {
    window.onpopstate = () => {
      // Push the user forward again to prevent back
      window.history.pushState(null, '', window.location.href);
    };
    setBackButtonHandler(() => {
      return () => {
        handleBackNavigation();
      };
    });
  }, [
    selectedNudge,
    monthlyPaymentsVisible,
    isKeyInshigtsVisible,
    location.state,
  ]);

  const [scrolled, setScrolled] = useState(false);

  // Callback function for back navigation

  useEffect(() => {
    window.onscroll = function () {
      if (window.scrollY > 18) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      {/* <div
        className={styles.backButton}
        style={{ boxShadow: scrolled ? '0 4px 10px #00000029' : 'none' }}
      >
        <div
          style={{
            height: 24,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
          }}
        >
          <BackButton
            onClick={() => {
              navigate(-1);
            }}
          />
          <PbMoney />
        </div>
      </div> */}

      <NavigationHeader
        header={
          monthlyPaymentsVisible
            ? 'My Recurring Payments'
            : selectedNudge
            ? selectedNudge.title
              ? selectedNudge.title
              : startCase(selectedNudge.category)
            : 'Account Insights'
        }
        onBack={handleBackNavigation}
      />

      {monthlyPaymentsVisible ? (
        <RecurringTransactions
          showAllPayments={true}
          selectedAccounts={
            accRecurringPayments ? { accNo: accRecurringPayments } : undefined
          }
          isFilterOptions={true}
          onGoback={() => {
            setMonthlyPaymentsVisible(false);
          }}
        />
      ) : selectedNudge !== undefined ? (
        <>
          <NudgeDetails
            selectedNudge={selectedNudge}
            selectedNudgeTransaction={selectedNudgeTransaction}
          />
        </>
      ) : (
        <div className={styles.moreInsightsRoot}>
          <HeaderSubHeader header='Some key aspects we noticed in your accounts' />

          <div className={styles.insightsRoot}>
            {nudges
              .filter(
                (nudge: any) =>
                  nudge.meta?.displayMode === 'default' ||
                  nudge.meta?.displayMode === undefined ||
                  nudge.meta?.displayMode === null
              )
              .map((nudge: any, index: number) => {
                const txnRefIdListParam = nudge.parameter?.find(
                  (param: any) => param.name === 'txnRefIdList'
                );
                const isEmptyTxnRefIdList =
                  txnRefIdListParam &&
                  Array.isArray(txnRefIdListParam.value) &&
                  txnRefIdListParam.value.length === 0;

                return (
                  <>
                    <div
                      onClick={() => {
                        if (isEmptyTxnRefIdList) {
                          return;
                        }

                        navigate(`/insights`);
                        pushEventToParent({
                          eventCode: 'INSIGHT_' + nudge.category,
                        });
                        setSelectedNudge(nudge);

                        if (
                          nudge.category === 'UPCOMING_EMI_REMINDER' ||
                          nudge.category === 'UPCOMING_SIP_INVESTMENT'
                        ) {
                          setMonthlyPaymentsVisible(true);
                        }
                      }}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: isEmptyTxnRefIdList ? 'default' : 'pointer',
                      }}
                    >
                      <NudgeItem
                        nudge={nudge}
                        isNotClickable={isEmptyTxnRefIdList}
                      />
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default NudgesScreenDashboard;
